import { AppEnvironment } from "src/app/constants/AppEnvironment.constants";

export const environment = {
  production: false,
  name: AppEnvironment.Test,
  
  // Auth config for CalAngularModule
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: 'sessionStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: '67102987-ed83-4d7c-9029-543ad65e3852',
  redirectUri: 'https://idamp-test.azure.chevron.com',
  tokenScopes: ['67102987-ed83-4d7c-9029-543ad65e3852/.default'],
  oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  graphScopes: ['User.Read', 'User.Read.All'],
  
  // App-specific config
  idampUserDefaultDomain: 'chevron.onmicrosoft.com',
  idampApiBaseUrl: 'https://idamp-api-test.azure.chevron.com/api',
  primaryUserApiBaseUrl: 'https://idapis-primaryuser-test.azure.chevron.com/api',
  idampOtherApiBaseUrl: 'https://idapis-api-other-test.azure.chevron.com/api',
  alertInfoMessage: 'If you need access, please submit a ticket',
  cmdbServiceIdUrlReplaceToken: '[[SERVICEID]]',
  cmdbServiceIdUrl: 'https://chevron.service-now.com/now/nav/ui/classic/params/target/cmdb_ci_business_app_list.do%3Fsysparm_query%3Dsys_class_name%253Dcmdb_ci_business_app%255Eu_appid%253D[[SERVICEID]]%26sysparm_first_row%3D1%26sysparm_view%3D',
  
  isClientSecretConfigCapabilitiesEnabled: false,
  isManagedIdentityPermissionRequestCapabilitiesEnabled: false,

  // AI least-privilege evaluator feature flag.
  // Keys and endpoints are held by the backend (Key Vault / App Settings).
  lpEvaluator: {
    enabled: true,
  },
};
